
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { RevLink } from '@ds/components/Link'
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import translations from './LandingNavigation.translations'
import {
  DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  MIN_CHILDREN_NUMBER,
} from './constants'

export default {
  name: 'LandingNavigation',
  components: {
    RevButtonTiny,
    RevLink,
  },
  props: {
    navigation: {
      type: Object,
      required: true,
    },
    currentLandingId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLongList: false,
    }
  },
  computed: {
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    hasNavigationToDisplay() {
      return (
        !isEmpty(this.navigation) &&
        !isEmpty(this.navigation.parent_nav) &&
        !isEmpty(this.navigation.children)
      )
    },
    parentNav() {
      if (isEmpty(this.navigation)) {
        return []
      }

      return this.navigation.parent_nav
        .filter((parent) => !isEmpty(parent.link))
        .map((parent, index) => ({
          ...parent,
          trackingParams: {
            name: parent.title,
            zone: 'product list > seo nav',
          },
          variant: this.isActive(parent.id) ? 'body-2-bold' : 'body-2-light',
          link: parent.link,
          styles: this.elementMarginLeft(index),
        }))
    },
    childrenNav() {
      if (isEmpty(this.navigation)) {
        return []
      }

      return this.navigation.children
        .filter((child) => !isEmpty(child.link))
        .map((child, index) => {
          const isLongListDisplayed = this.isLongListDisplayed(index)
          const isExtraNavigation = index > MIN_CHILDREN_NUMBER - 1

          const classes = {
            'ml-0': index === 0,
            block: isExtraNavigation || isLongListDisplayed,
            'lg:hidden': isExtraNavigation && !isLongListDisplayed,
          }

          const listTestId = {
            isExtraNavigation,
            isMoreNavigationDisplayed: isLongListDisplayed,
          }

          const testIdKey = Object.keys(listTestId)
          const testId = Object.values(listTestId).reduce(
            (acc, id, testIdIndex) => {
              if (id) {
                return `${acc} ${testIdKey[testIdIndex]}`
              }

              return acc
            },
            '',
          )

          return {
            ...child,
            trackingParams: {
              name: child.title,
              zone: 'product list > seo nav',
            },
            variant: this.isActive(child.id) ? 'body-2-bold' : 'body-2-light',
            link: child.link,
            testId,
            classes,
            styles: this.elementMarginLeft(this.parentNav.length),
          }
        })
    },
    hasEnoughChildren() {
      return this.childrenNav.length > MIN_CHILDREN_NUMBER
    },
    ctaWording() {
      return this.isLongList
        ? this.$t(translations.viewLess)
        : this.$t(translations.viewMore)
    },
    translations: () => translations,
  },
  methods: {
    trackClick(params) {
      trackClick(params)
    },
    isActive(id) {
      return this.currentLandingId === id.toString()
    },
    elementMarginLeft(index) {
      return { marginLeft: `${index * 1.6}rem` }
    },
    changeNumberOfDisplayedChildren() {
      this.isLongList = !this.isLongList
    },
    isLongListDisplayed(index) {
      return index > MIN_CHILDREN_NUMBER - 1 && this.isLongList
    },
  },
}
